import React from "react";

const MiracleTitle = () => {
  return (
    <div className="title-container centre-row-margin-top">
      <span className="text-muted title-centered">
        <h3 className="marginBottom">Miracle Girls - English Translation</h3>
        <h4>
          <div>ミラクル★ガールズ</div>
        </h4>
      </span>
    </div>
  );
};

export default MiracleTitle;



// WEBPACK FOOTER //
// ./src/lib/MiracleTitle.js